import React from 'react';
import FormGroupTextInput from "../formGroupTextInput";
import Dots from "react-activity/lib/Dots/index";
import FormResponseMessage from "../formResponseMessage";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import {Link} from "react-router-dom";
import CustomModal from "../General/customModal";
import { LEGAL_ADVICE_TEXT } from '../../helpers/variables';

const ManageBrokerAccount = (props) => {
    const {broker, changeBroker, _handleSubmit, fetchingBroker, formSuccessMsg, formErrors, loading,
        openBrokerPasswordModal, closeBrokerPasswordModal, isChangePasswordModalOpen, _changePasswordForm,
        passwordForm, _submitChangedPassword, updatingPassword, updatePasswordError} = props;
    if(fetchingBroker){
        return (
            <div className={'col-sm-12'}>
                <CenteredDots/>
            </div>
        )
    }
    return (
        <div>
            <CustomModal
                contentClassname='tobas__toba-modal'
                isOpen={isChangePasswordModalOpen}
                content={<div>
                    <div className={'row'}>
                        <div className={'col-sm-12'}>
                            <form className="form-horizontal" onSubmit={_submitChangedPassword}>
                                <FormGroupTextInput
                                    InputWrapper="col-sm-6"
                                    Label="Current Password"
                                    Type="password"
                                    Name="password"
                                    Value={passwordForm.password}
                                    HandleInputChange={_changePasswordForm}
                                />
                                <FormGroupTextInput
                                    InputWrapper="col-sm-6"
                                    Label="New Password"
                                    Type="password"
                                    Name="newPassword"
                                    Value={passwordForm.newPassword}
                                    HandleInputChange={_changePasswordForm}
                                />
                                <FormGroupTextInput
                                    InputWrapper="col-sm-6"
                                    Label="Retype New Password" Type="password"
                                    Name="retypedNewPassword"
                                    Value={passwordForm.retypedNewPassword}
                                    HandleInputChange={_changePasswordForm}/>
                                <div className="row">
                                    <div className="col-sm-6 col-sm-offset-3">
                                        <Button
                                            wrapper="btn-wrapper-forForms"
                                            btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                            label="Confirm"/>
                                        <Button
                                            clickHandler={closeBrokerPasswordModal}
                                            wrapper="btn-wrapper-forForms"
                                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                                            label="Cancel"/>
                                    </div>
                                </div>
                                {updatePasswordError && (
                                    <FormResponseMessage
                                        Message={updatePasswordError}
                                        CenterWrapper="col-sm-6 col-sm-offset-3"
                                        MessageStyle="formResponseMessage-reject"
                                    />
                                )}
                            </form>
                        </div>
                        {updatingPassword && (
                            <div className={'col-sm-12'}>
                                <CenteredDots/>
                            </div>
                        )}
                    </div>
                </div>}
                handleClose={closeBrokerPasswordModal}
            />
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <h2 className="manageSolicitorAccount-h2">Manage Account</h2>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <form className="form-horizontal">
                        <div className="form-group">
                            <div className="col-sm-3">
                                <label className="control-label.text-left formGroup-textInput-label">Email address / Username</label>
                            </div>
                            <div className="col-sm-6">
                                <label
                                    className="control-label.text-left manageSolicitorAccount-data">{broker.email}{' / '}{broker.username}</label>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-6 col-sm-offset-3">
                                <Button
                                    clickHandler={openBrokerPasswordModal}
                                    wrapper="btn-wrapper"
                                    btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label="Change Password"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-3">
                                <label className="control-label.text-left formGroup-textInput-label">Name</label>
                            </div>
                            <div className="col-sm-6">
                                <label
                                    className="control-label.text-left manageSolicitorAccount-data">{broker.forename}{' '}{broker.surname}</label>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                        <div className="form-group formGroup-noBottomMargin">
                            <div className="col-sm-3">
                                <label className="control-label.text-left formGroup-textInput-label">Broker</label>
                            </div>
                            <div className="col-sm-6">
                                <label
                                    className="control-label.text-left manageSolicitorAccount-data">{broker.lawsysName}</label>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-3">
                                <label className="control-label.text-left formGroup-textInput-label">Address</label>
                            </div>
                            <div className="col-sm-6">
                                <ul className="manageSolicitorAccount-ul">
                                    <li>{broker.addressLine1}</li>
                                    <li>{broker.addressLine2}</li>
                                    <li>{broker.city}</li>
                                    <li>{broker.postCode}</li>
                                    <li>{broker.country}</li>
                                </ul>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                    </form>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <hr className="manageSolicitorAccount-hr"/>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <form className="form-horizontal" onSubmit={_handleSubmit}>
                        <FormGroupTextInput
                            InputWrapper="col-sm-6"
                            Label="Forename"
                            Type="text"
                            Placeholder={`${LEGAL_ADVICE_TEXT}'s Name`}
                            Name="forename"
                            Value={broker.forename}
                            HandleInputChange={(name ,value) => changeBroker({key: name, value: value})}
                        />
                        <FormGroupTextInput
                            InputWrapper="col-sm-6"
                            Label="Surname"
                            Type="text"
                            Placeholder={`${LEGAL_ADVICE_TEXT}'s Surname`}
                            Name="surname"
                            Value={broker.surname}
                            HandleInputChange={(name ,value) => changeBroker({key: name, value: value})}
                        />
                        <FormGroupTextInput
                            InputWrapper="col-sm-6"
                            Label="Telephone number 1"
                            Type="text"
                            Name="telephone1"
                            Value={broker.telephone1}
                            HandleInputChange={(name ,value) => changeBroker({key: name, value: value})}
                        />
                        <FormGroupTextInput
                            InputWrapper="col-sm-6"
                            Label="Telephone number 1 description"
                            Type="text"
                            Name="telephone1Description"
                            Value={broker.telephone1Description}
                            HandleInputChange={(name ,value) => changeBroker({key: name, value: value})}
                        />
                        <FormGroupTextInput
                            InputWrapper="col-sm-6"
                            Label="Telephone number 2"
                            Type="text"
                            Name="telephone2"
                            Value={broker.telephone2}
                            HandleInputChange={(name ,value) => changeBroker({key: name, value: value})}
                        />
                        <FormGroupTextInput
                            InputWrapper="col-sm-6"
                            Label="Telephone number 2 description"
                            Type="text"
                            Name="telephone2Description"
                            Value={broker.telephone2Description}
                            HandleInputChange={(name ,value) => changeBroker({key: name, value: value})}
                        />
                        <div className="form-group">
                            <div className="col-sm-6 col-sm-offset-3">
                                <Button
                                    wrapper="btn-wrapper"
                                    btnType="submit"
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label={'Update'}/>
                            </div>
                        </div>
                        {formSuccessMsg && (
                            <FormResponseMessage
                                Message={formSuccessMsg}
                                CenterWrapper="col-sm-6 col-sm-offset-3"
                                MessageStyle="formResponseMessage-success"
                            />
                        )}
                        {formErrors.length > 0 && (
                            <FormResponseMessage
                                Message={<ul className={'unorderedListNoBulletsAndSpace'}>{formErrors.map(
                                    (error, index) => (<li key={index}>{error}</li>))}</ul>
                                }
                                CenterWrapper="col-sm-6 col-sm-offset-3"
                                MessageStyle="formResponseMessage-reject"
                            />
                        )}
                    </form>
                </div>
                {loading && (
                    <div className={'col-sm-12'}>
                        <CenteredDots/>
                    </div>
                )}
            </div>
        </div>
    )
};

export default ManageBrokerAccount;